

import {
    HttpResponse,
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpErrorResponse
} from '@angular/common/http';
import { Observable, tap, finalize, debounceTime, distinctUntilChanged } from 'rxjs';
import { Injectable } from '@angular/core';
import { LoaderService } from "./loader.service";
import { ToastService } from '../services/toast.service';

@Injectable({
  providedIn: 'root'
})
export class LoaderInterceptor {
    private activeRequests = 0;
    private debounceTime = 100; // 🔥 Debounce to prevent flickering

    constructor(
        private loaderService: LoaderService,
        private toastService: ToastService
    ) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // 🔥 Only show loader for requests that take longer than debounce time
        const showLoader = () => {
            this.activeRequests++;
            if (this.activeRequests === 1) {
                this.loaderService.isLoading.next(true);
            }
        };

        const hideLoader = () => {
            this.activeRequests--;
            if (this.activeRequests === 0) {
                this.loaderService.isLoading.next(false);
            }
        };

        // 🔥 Show loader immediately for critical requests, debounce others
        const isCritical = req.url.includes('/api/') || req.url.includes('/auth/');
        if (isCritical) {
            showLoader();
        } else {
            setTimeout(showLoader, this.debounceTime);
        }

        return next.handle(req).pipe(
            tap({
                next: (event) => {
                    if (event instanceof HttpResponse) {
                        // Success - no action needed
                    }
                },
                error: (error: HttpErrorResponse) => {
                    this.handleError(error);
                }
            }),
            finalize(() => {
                // 🔥 Debounce hiding loader
                setTimeout(hideLoader, this.debounceTime);
            })
        );
    }

    private handleError(error: HttpErrorResponse): void {
        console.log(error);
        if (error.status === 555) {
            this.toastService.showWarningToast('Oops! this service is in maintenance mode, please, try after sometime');
        } else if (error.error && error.error?.status !== 500 && error.error?.status !== 'M0000') {
            if (error.error.message !== undefined && error.error.message !== 'No message available') {
                this.toastService.showErrorToast(error.error.message);
            }
        } else {
            this.toastService.showErrorToast('Oops! Something went wrong.');
        }
    }
}
